import { createSelector } from "reselect"
import { getUrlParams } from '@utils/utils'

const selectAuth = state => state.auth;

export const selectProfile = createSelector(
  selectAuth,
  auth => auth.userData
);

export const selectAdmin = createSelector(
  selectAuth,
  auth => auth?.userData?.role === 'admin'
);

export const selectLang = createSelector(
  selectAuth,
  auth => {
    let { lang } = getUrlParams(['lang'])
    if (!lang || !['th', 'en'].includes(lang)) lang = auth?.userData?.language || null
    return lang || 'th'
  }
);

export const selectAccountAdmin = createSelector(
  selectAuth,
  auth => auth?.userData?.role === 'account-admin'
);
export const selectSeller = createSelector(
  selectAuth,
  auth => auth?.userData?.role === 'seller'
);